export const cacheKeys = {
  getChat: 'getChat',
  getChats: 'getChats',
  createChat: 'createChat',
  editChat: 'editChat',
  deleteChat: 'deleteChat',
  archiveChat: 'archiveChat',
  unarchiveChat: 'unarchiveChat',
};
